var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroMessaging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.781,
    height: 43.565,
    viewBox: "0 0 44.781 43.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.216,6.946H6.565A6.51,6.51,0,0,0,0,13.4V33.686A6.51,6.51,0,0,0,6.565,40.14h9.366l5.676,9.782a1.184,1.184,0,0,0,2.066-.032l5.257-9.75h9.287a6.51,6.51,0,0,0,6.565-6.454V13.4a6.51,6.51,0,0,0-6.565-6.454Z",
    transform: "translate(0 -6.946)",
    fill: "#0089ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.8,6.972H258.177V50.534a1.172,1.172,0,0,0,1.085-.619l5.257-9.75H273.8a6.51,6.51,0,0,0,6.565-6.454V13.426A6.51,6.51,0,0,0,273.8,6.972Z",
    transform: "translate(-235.589 -6.97)",
    fill: "#295fcc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.572,
    cy: 4.572,
    r: 4.572,
    transform: "translate(28.969 8.241)",
    fill: "#fc9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M383.366,101.135v9.143a4.572,4.572,0,0,0,0-9.143Z",
    transform: "translate(-349.825 -92.894)",
    fill: "#ffb366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.963,213.722h-6a4.615,4.615,0,0,0-4.579,4.615v1.036a1.209,1.209,0,0,0,1.209,1.209h12.776a1.209,1.209,0,0,0,1.209-1.209v-1.036A4.616,4.616,0,0,0,306.963,213.722Z",
    transform: "translate(-270.455 -195.631)",
    fill: "#ff405c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M386.333,213.722h-2.967v6.861h6.375a1.209,1.209,0,0,0,1.209-1.209v-1.036A4.616,4.616,0,0,0,386.333,213.722Z",
    transform: "translate(-349.825 -195.631)",
    fill: "#c1126b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.572,0A4.572,4.572,0,1,1,0,4.572,4.572,4.572,0,0,1,4.572,0Z",
    transform: "translate(7.184 8.241)",
    fill: "#d0aa84"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M383.366,101.135v9.143a4.572,4.572,0,0,0,0-9.143Z",
    transform: "translate(-371.61 -92.894)",
    fill: "#c78e54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M306.963,213.722h-6a4.615,4.615,0,0,0-4.579,4.615v1.036a1.209,1.209,0,0,0,1.209,1.209h12.776a1.209,1.209,0,0,0,1.209-1.209v-1.036A4.616,4.616,0,0,0,306.963,213.722Z",
    transform: "translate(-292.24 -195.631)",
    fill: "#40ffae"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M386.333,213.722h-2.967v6.861h6.375a1.209,1.209,0,0,0,1.209-1.209v-1.036A4.616,4.616,0,0,0,386.333,213.722Z",
    transform: "translate(-371.61 -195.631)",
    fill: "#12c177"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroMessaging);
export default __webpack_public_path__ + "static/media/Asset-KuroMessaging.ab682170230b78d68146802977270b61.svg";
export { ForwardRef as ReactComponent };